import {
  DemoIndicatorColoredIcon,
  GlobalIcon,
  TourIndicatorColoredIcon,
} from '@carboncopyco/icons';
import {
  type PlaybookAsset,
  type PlaybookAssetType,
  RecordingTypes,
  isDemoAssetType,
  isExternalUrlAssetType,
  isTourAssetType,
} from '@carboncopyco/types';
import type { ReactNode } from 'react';

export const iconByAssetType: Record<PlaybookAssetType, ReactNode> = {
  demo: <DemoIndicatorColoredIcon size={20} />,
  tour: <TourIndicatorColoredIcon size={20} />,
  externalUrl: <GlobalIcon size={20} />,
};

export const getIconTitle = (entity: PlaybookAsset['entity']) => {
  if (isDemoAssetType(entity)) {
    return `Demo (${entity.recordingType === RecordingTypes.overlay ? 'live' : 'cloned'} app)`;
  }
  if (isTourAssetType(entity)) {
    return 'Tour';
  }
  return 'External URL';
};

export const getPlaybookAssetTitle = (entity: PlaybookAsset['entity']) => {
  if (isDemoAssetType(entity)) {
    return entity.demoName;
  }
  if (isTourAssetType(entity)) {
    return entity.tourName;
  }
  if (isExternalUrlAssetType(entity)) {
    return entity.name;
  }
};
